import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Card from "./Card";

// Responsive
const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 5,
    slidesToSlide: 5,
  },
  tablet: {
    breakpoint: { max: 1024, min: 850 },
    items: 4,
    slidesToSlide: 4,
  },
  minitab: {
    breakpoint: { max: 850, min: 464 },
    items: 2,
    slidesToSlide: 2,
  },
  smallphone: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    slidesToSlide: 1,
  },
};

function ImageSlider({ cardData, autoPlay }) {
  const [deviceType, setDeviceType] = useState("desktop");

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width >= responsive.desktop.breakpoint.min) {
        setDeviceType("desktop");
      } else if (
        width >= responsive.tablet.breakpoint.min &&
        width < responsive.desktop.breakpoint.min
      ) {
        setDeviceType("tablet");
      } else {
        setDeviceType("smallphone");
      }
    };

    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <Container className="p-0">
        <Carousel
          swipeable={false}
          draggable={false}
          showDots={false}
          arrows={deviceType === "smallphone"}
          responsive={responsive}
          ssr={true}
          infinite={false}
          autoPlay={false}
          customTransition="none"
          transitionDuration={0}
          deviceType={deviceType}
          additionalTransform={0}
        >
          {cardData.map((card, index) => (
            <Card key={`dup-${index}`} image={card.image} text={card.text} />
          ))}
        </Carousel>
      </Container>
    </>
  );
}

export default ImageSlider;
